import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { StockOperation } from '../models/stock-operation.model';
import { StockQuantityService } from '../services/stock-quantity.service';

@Injectable({
  providedIn: 'root'
})
export class StockOperationValidatorService extends ValidatorService {

  constructor(private stockQuantityService: StockQuantityService) {
    super();
  }

  /**
   * @param data the operation being posted
   * @param isTransfer transfers additionally need a destination that differs from the source
   * @param isAdjustment an adjustment carries a signed qty, so it only has to be non-zero
   */
  isValid(data: StockOperation, isTransfer: boolean = false, isAdjustment: boolean = false) {
    this.errors = [];

    if (!this.isDropdownSupplied(data.referenceId)) {
      this.errors.push('referenceId');
    }

    if (!data.lines || data.lines.length === 0) {
      this.errors.push('lines');
      return false;
    }

    data.lines.forEach((line, index) => {

      if (!this.isDropdownSupplied(line.productId)) {
        this.errors.push('productId-' + index);
      }

      if (!this.isDropdownSupplied(line.warehouseLocationId)) {
        this.errors.push('warehouseLocationId-' + index);
      }

      // qty is a float, so it is never compared against zero exactly.
      if (!this.isSupplied(line.qty)
        || (isAdjustment ? this.stockQuantityService.isZero(line.qty) : !this.stockQuantityService.isPositive(line.qty))) {
        this.errors.push('qty-' + index);
      }

      if (isTransfer) {
        if (!this.isDropdownSupplied(line.toWarehouseLocationId)) {
          this.errors.push('toWarehouseLocationId-' + index);
        } else if (line.toWarehouseLocationId === line.warehouseLocationId) {
          this.errors.push('toWarehouseLocationId-' + index);
        }
      }
    });

    return this.errors.length === 0;
  }

  hasError(field: string): boolean {
    return this.errors.indexOf(field) !== -1;
  }
}
